import { useState, useEffect, useRef } from "react";

import styled, { keyframes } from "styled-components";

// import Link from "next/link";
// import { Row } from "react-bootstrap";

import useDeviceSize from "src/hooks/useDeviceSize";

// import { Controller } from "react-hook-form";
import { useFieldArray } from "react-hook-form";

import device from "src/styles/device";
// import { replaceProductUrl } from "lib/common";

import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { Stack } from "@mui/material";
import Button from "src/components/core/Button";

import font from "src/styles/font";
import { MAX_SPOT_PER_IMAGE } from "src/modules/blog/BlogCreate";
import { Red } from "src/styles/color";

const S = {};

S.Container = styled.div`
  position: relative;
  padding-top: ${(props) => 100 / props.aspectRatio}%;
  /* background-color: #f2f1f2;
  border-radius: 15px;
  background-image: url(${(props) => props.previewImage});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover; */
  /* height: fit-content; */
`;

S.SpottableImage = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  border-radius: 15px;
  object-fit: cover;
`;

S.Spots = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
`;

const pulsate = keyframes`
  0% {
    transform: scale(1);
    opacity:0.8;
  }
  85% {
    transform: scale(1.75);
    opacity:0;
  }
`;
const stopPulsate = keyframes`
  from {
    opacity:0.4;
  }
  to {
    transform: scale(2);
    opacity:0;
  }
`;

S.WrapperImageSpot = styled.div`
  width: 70%;
  padding-top: 70%;
  position: relative;
  background-image: url("https://xsurface-images.s3.ap-southeast-1.amazonaws.com/Focus_1.png");
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
`;

S.ImageSpot = styled.img`
  width: 70%;
  height: 70%;
  border-radius: 10px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

S.LabelSpot = styled.div`
  text-align: center;
  margin-top: 10px;
  font-size: 0.625rem;
  letter-spacing: 0.5px;
  color: #363638;
  background-color: #f3f1f2;
  border-radius: 25px;
  opacity: 1;
  padding: 0 8%;
  width: 180px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  @media ${device.tabletL} {
    width: 150px;
  }
  @media ${device.mobileL} {
    width: 120px;
    font-size: 0.625rem;
  }
`;

S.BlockHoverProduct = styled.div`
  position: absolute;
  display: none;
  line-height: 1.5em;
  color: #fff;
  transition: display 1s;
  right: ${(props) => (props.isRight ? "0px !important" : "")};
  z-index: 2;
  width: 180px;
  @media ${device.tabletL} {
    width: 150px;
  }
  @media ${device.mobileL} {
    width: 120px;
  }

  /* top: ${(props) => `${props.posY}%`};
  left: ${(props) => `${props.posX}%`};
  display: block;
  cursor: pointer; */
`;

S.ProductDetailFeature = styled.div`
  display: flex;
  flex-wrap: wrap;

  margin: 0% 0 0 0%;
  cursor: pointer;
  justify-content: center;
  background-color: ${(props) => props.bgColor};
  max-width: 100%;
  height: ${(props) => (props.emptyHeight ? props.emptyHeight : "auto")};
  padding: 5%;
  z-index: 10 !important;
  border-radius: 10px;
  border: none;
`;

S.A = styled.a`
  display: flex;
  width: 150px;
  position: absolute;
  top: -10px;
  left: ${(props) => (props.left ? "-130px" : "10px")};
`;

S.WrapperSpot = styled.div`
  top: ${(props) => `${props.top}%`};
  right: ${(props) => `${props.right}%`};
  left: ${(props) => `${props.left}%`};
  position: absolute;
  display: inline-block;
  user-select: none;
  z-index: ${(props) => props.zIndex};

  &.right .side-right {
    right: 0 !important;
  }

  &:hover {
    &.right .blockquote {
      display: block;
      cursor: pointer;
    }

    &.left .blockquote {
      display: block;
      cursor: pointer;
    }
  }
`;

S.Spot = styled.div`
  position: absolute;
  width: 25px;
  height: 25px;
  background-color: #f3f1f2;
  border-radius: 50%;
  color: red;
  font-size: 1.5rem;
  overflow: hidden;
  z-index: 10;

  &:hover {
    background-color: #f3f1f2;
    cursor: pointer;
  }
  &:active {
    transform: scale(0.875);
  }

  @media ${device.laptop} {
    width: 20px;
    height: 20px;
  }
  @media ${device.mobileL} {
    width: 10px;
    height: 10px;
  }
`;

S.BorderSpots = styled.div`
  display: block;
  position: absolute;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  border: ${({ error }) => (error ? `2px solid ${Red}` : "1px solid #f3f1f2")};
  opacity: 0;
  animation: ${pulsate} 1.5s ease-out infinite;
  z-index: 10;

  &:hover {
    animation: none;
  }

  &:active {
    animation: ${stopPulsate} 0.3s;
  }
  @media ${device.laptop} {
    width: 20px;
    height: 20px;
  }
  @media ${device.mobileL} {
    width: 10px;
    height: 10px;
  }
`;

S.SpotProductPopup = styled.div`
  padding: 16px;
  width: 300px;
  background-color: #fff;
  border-radius: 16px;
  position: absolute;
  /* top: 20px;
  left: 20px; */
  top: ${(props) => `${props.posY}%`};
  left: ${(props) => `${props.posX}%`};
  z-index: 10;
`;

S.SelectedProduct = styled.div`
  display: flex;
  margin-top: 16px;
`;

S.SelectedProductLabel = styled.span`
  display: block;
  font-size: ${font.size.xs};
`;

S.SelectedProductImage = styled.img`
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 16px;
`;

S.SelectedProductInfo = styled.div`
  padding-left: 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
`;

S.SpottingBoard = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
`;

const convertPrice = (price) =>
  Intl.NumberFormat("th-TH", {
    style: "currency",
    currency: "THB",
  }).format(price);

export const HotspotElement = ({
  mode,
  hoveringId,
  setHoveringId,
  editingId,
  setEditingId,
  hotspot,
  index,
  error,
}) => {
  const [deviceWidth] = useDeviceSize();
  const [elePos, setElePos] = useState(null);

  const spotRef = useRef(null);

  /**
   * @dev Used to determine where the popup should be on the left or right side.
   */
  useEffect(() => {
    const div = spotRef.current;
    const ele = div.getBoundingClientRect();
    setElePos(ele);
  }, [spotRef, deviceWidth]);

  return (
    <S.WrapperSpot
      ref={spotRef}
      top={hotspot.position_y}
      left={hotspot.position_x}
      className={hotspot.left ? "left" : "right"} // 5 Sep 23 will refactor this later
      zIndex={hoveringId === index ? 99 : 10}
    >
      <S.BorderSpots error={error} />
      <S.Spot
        onMouseEnter={() => {
          if (mode !== "view-only") return;
          setHoveringId(index);
        }}
        onClick={() => {
          if (mode === "edit") {
            if (editingId === index) {
              setEditingId(null);
            } else {
              setEditingId(index);
            }
          }
        }}
      />
      {/* If viewing in view-only mode, display the product popup when hovering on the spot. */}
      {mode === "view-only" && hoveringId === index && (
        <>
          <S.BlockHoverProduct className="blockquote">
            {/* <Link
                href={replaceProductUrl(`${hotspot.pc_id?._id}`)}
                as={replaceProductUrl(
                  `${hotspot.pc_id?.product?.user?.seller?.company_name} -${hotspot.pc_id?.brands?.name} -${hotspot.pc_id?.product?.item_code} -${hotspot.pc_id?.product?.item_name}=${hotspot.pc_id?._id}`
                )}
              > */}
            <S.A
              onMouseDown={() => {
                setHoveringId(index);
              }}
              onMouseLeave={() => {
                setHoveringId(null);
              }}
              left={deviceWidth <= 835 && elePos?.x > deviceWidth / 2}
            >
              <S.ProductDetailFeature>
                <S.WrapperImageSpot>
                  <S.ImageSpot
                    src={
                      hotspot?.pc_id?.group_image?.product_display_image
                        ? hotspot?.pc_id?.group_image?.product_display_image.replace(
                            ".com",
                            ".com/300x300",
                          )
                        : ""
                      // hotspot.pc_id?.group_image?.product_full_image
                    }
                    alt={`${hotspot.pc_id?.product?.item_name} product full image`}
                  />
                </S.WrapperImageSpot>
                <S.LabelSpot>{hotspot.pc_id?.product?.item_name}</S.LabelSpot>
              </S.ProductDetailFeature>
            </S.A>
            {/* </Link> */}
          </S.BlockHoverProduct>
        </>
      )}
    </S.WrapperSpot>
  );
};

const SpottableImage = ({
  formControl,
  mode,
  aspectRatio,
  previewImage,
  hotspot,
  hotspotArrayKey,
  productOptions,
  onSelectProduct,
}) => {
  // const [selectedProduct, setSelectedProduct] = useState(null);
  const [editingId, setEditingId] = useState(null);
  const [hoveringId, setHoveringId] = useState(null);

  const editingObject = hotspot[editingId];

  const { append: appendSpot, remove: removeSpot } = useFieldArray({
    control: formControl,
    name: hotspotArrayKey,
  });

  /**
   * @dev use to close opening spot popup when click outside the editing panel
   */
  const editingSpotPopupEl = useRef(null);
  useEffect(() => {
    const handleClick = (e) => {
      // If the active element exists and is clicked outside of
      if (
        editingSpotPopupEl.current &&
        !editingSpotPopupEl.current.contains(e.target)
      ) {
        setEditingId(null);
      }
    };
    // Listening for click event, and adjust listener to fire on the capturing phase only
    window.addEventListener("click", handleClick, true);
    return () => {
      window.removeEventListener("click", handleClick, true);
    };
  }, [editingSpotPopupEl]);

  const handleAddSpot = (e) => {
    if (hotspot.length === MAX_SPOT_PER_IMAGE) return;

    const { left, top, width, height } = e.target.getBoundingClientRect();
    const x = ((e.clientX - left - 25 / 2) / width) * 100; // which spot size is 25px, so -12.5px in x axis to be more precisely positioned with the cursor position
    const y = ((e.clientY - top - 25 / 2) / height) * 100; // which spot size is 25px, so -12.5px in y axis to be more precisely positioned with the cursor position

    editingId === null
      ? appendSpot({
          position_x: x,
          position_y: y,
          pc_id: null,
        })
      : setEditingId(null);
  };

  const handleClearSpot = (index) => {
    removeSpot(index);
    setEditingId(null);
  };

  return (
    <S.Container aspectRatio={aspectRatio}>
      <S.SpottableImage src={previewImage} alt="" />
      <S.Spots>
        {hotspot?.length > 0 &&
          hotspot?.map((hotspot, index) => {
            return (
              <HotspotElement
                key={index}
                index={index}
                hotspot={hotspot}
                mode={mode}
                hoveringId={hoveringId}
                setHoveringId={setHoveringId}
                editingId={editingId}
                setEditingId={setEditingId}
                error={!!hotspot?.pc_id ? false : true}
              />
            );
          })}
      </S.Spots>
      {/* Show the spotting board only when there is no open spot popup. */}
      {mode === "edit" && editingId === null && (
        <S.SpottingBoard onClick={handleAddSpot} />
      )}
      {mode === "edit" && editingId !== null && (
        <S.SpotProductPopup
          ref={editingSpotPopupEl}
          posX={editingObject.position_x + 2.5}
          posY={editingObject.position_y + 2.5}
        >
          <Autocomplete
            disablePortal
            options={productOptions}
            getOptionLabel={(option) =>
              `${option.product.item_code} ${option.product.item_name}`
            }
            isOptionEqualToValue={(option, value) => option._id === value._id}
            fullWidth
            renderInput={(params) => (
              <TextField {...params} label="Choose a product" />
            )}
            value={editingObject?.pc_id}
            onChange={(e, value) => onSelectProduct(value, editingId)}
          />
          {editingObject?.pc_id && (
            <>
              <S.SelectedProductLabel style={{ marginTop: 16 }}>
                Selected product
              </S.SelectedProductLabel>
              <S.SelectedProduct>
                <S.SelectedProductImage
                  src={
                    editingObject?.pc_id?.group_image?.product_display_image
                      ? editingObject?.pc_id?.group_image?.product_display_image.replace(
                          ".com",
                          ".com/300x300",
                        )
                      : ""
                  }
                  alt={`${editingObject?.pc_id?.product?.item_name} product full image`}
                />
                <S.SelectedProductInfo>
                  <S.SelectedProductLabel>
                    {editingObject?.pc_id?.product?.item_name}
                  </S.SelectedProductLabel>
                  <S.SelectedProductLabel>
                    {editingObject?.pc_id?.product?.item_code}
                  </S.SelectedProductLabel>
                  <S.SelectedProductLabel>
                    {convertPrice(
                      editingObject?.pc_id?.group_price?.is_start_price === true
                        ? editingObject?.pc_id?.group_price?.start_price
                        : editingObject?.pc_id?.group_price.special_price > 0 &&
                            editingObject?.pc_id?.group_price.special_price !==
                              null &&
                            editingObject?.pc_id?.group_price.special_price !==
                              undefined
                          ? editingObject?.pc_id?.group_price.special_price
                          : editingObject?.pc_id?.group_price?.price,
                    )}
                  </S.SelectedProductLabel>
                </S.SelectedProductInfo>
              </S.SelectedProduct>
            </>
          )}
          <Stack sx={{ mt: 2 }} flexDirection={"row"} columnGap={1}>
            <Button
              variant="outlined"
              onClick={() => handleClearSpot(editingId)}
              fullWidth
              size="large"
            >
              Delete
            </Button>
            <Button
              variant="contained"
              onClick={() => setEditingId(null)}
              fullWidth
              size="large"
            >
              OK
            </Button>
          </Stack>
        </S.SpotProductPopup>
      )}
    </S.Container>
  );
};

export default SpottableImage;
